import React from 'react';
import { useLocation } from 'react-router-dom';

import { setPageTitle } from './header.utils';

import styles from './styles.scss';

const Header = () => {
    const { pathname } = useLocation();

    return (
        <header className={styles.header}>
            <h1 className={styles.header__title}>
                {setPageTitle(pathname)}
            </h1>
        </header>
    );
};

export default Header;
